import React, { useState, useRef, useEffect, useContext, useMemo } from 'react';
import ReactDOM from 'react-dom';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { FaEllipsis, FaEnvelope, FaUserLargeSlash } from 'react-icons/fa6';
import { BiSolidPencil } from 'react-icons/bi';
import { HiTrash } from 'react-icons/hi';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { authContext } from 'contexts/AuthContext';
import { collectPermissionNames, hasAnyPermission } from 'utils/permissions';
import VendorLoginButton from 'pages/Vendor/components/VendorLoginButton';

const VendorActionDropdown = ({
  cell,
  rowData,
  handleClickEdit,
  toggleDeleteRecord,
  toggleDeactivatePlan,
  drawerEmailToggle,
  tableName,
  showVendorLogin = true,
  toggleClassName = 'bg-transparent border-0 text-dark',
}) => {
  const { auth } = useContext(authContext);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggle = () => setIsOpen(!isOpen);
  const vendor = cell?.row?.original || rowData;

  const permissionNames = useMemo(
    () => collectPermissionNames(auth?.data),
    [auth?.data],
  );

  const hasVendorLoginPermission = useMemo(
    () => hasAnyPermission(permissionNames, ['ADMIN_LOGIN_AS_VENDOR']),
    [permissionNames],
  );

  const canShowVendorLogin = Boolean(showVendorLogin && hasVendorLoginPermission);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const dropdownContent = (
    <DropdownMenu className="cmn-dropdown">
      <DropdownItem
        onClick={() => handleClickEdit(vendor, ADD_EDIT_CONSTANT.EDIT)}
      >
        <BiSolidPencil /> Edit
      </DropdownItem>
      <DropdownItem onClick={() => drawerEmailToggle(vendor?.id)}>
        <FaEnvelope /> Send Mail
      </DropdownItem>
      {/* <DropdownItem>
      <MdCall /> Call
    </DropdownItem> */}
      <DropdownItem
        onClick={() => toggleDeactivatePlan(vendor?.id)}
        disabled={vendor?.isParentTrader ? !vendor?.userSubscription?.id : true}
      >
        <FaUserLargeSlash /> Deactivate Plan
      </DropdownItem>
      {canShowVendorLogin && (
        <VendorLoginButton row={{ original: vendor }} />
      )}
      {tableName === 'ALL' && (
        <DropdownItem onClick={() => toggleDeleteRecord(vendor?.id)}>
          <HiTrash /> Delete Account
        </DropdownItem>
      )}
    </DropdownMenu>
  );

  return (
    <div ref={dropdownRef}>
      <Dropdown isOpen={isOpen} toggle={toggle}>
        <DropdownToggle
          className={toggleClassName}
          onClick={(event) => event.stopPropagation()}
        >
          <FaEllipsis />
        </DropdownToggle>
        {ReactDOM.createPortal(dropdownContent, document.body)}
      </Dropdown>
    </div>
  );
};

export default VendorActionDropdown;
